// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ManageLsnsButton: 'manage-lsns-button',
	LinkReconnectButton: 'link-reconnect-button',
	LinkConnectButton: 'link-connect-button',
	AddLsnButton: 'add-lsn-button',
	ConnectButton: 'connect-button',
	EnrollNowButton: 'enroll-now-button',
	ConnectReconnectBtnLink: 'connect-reconnect-btn-link',
	ProfileLink: 'profile-link',
	EnrollNowLink: 'enroll-now-link',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
